import CaspianXXQueryProcessingHistoryItem from "../Domain/CaspianXXQueryProcessingHistoryItem.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import CaspianXXQueryProcessingHistorySearchParams from "../Contents/RoverImport/CaspianXXQueryProcessingHistoryAdmin/CaspianXXQueryProcessingHistorySearchParams";

export default class CaspianXXQueryProcessingHistoryService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, CaspianXXQueryProcessingHistorySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/CaspianXExtraQueryProcessingHistory/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map(item => new CaspianXXQueryProcessingHistoryItem(item));
    }

    return mappedItems;
  }
}
